export default __webpack_public_path__ + "static/media/typetruck.5b0b51e9.5b0b51e9.svg";